import React from 'react';
import { createRoot } from 'react-dom/client';
import LogoLoop, { LogoItem } from './LogoLoop';

const workImages: LogoItem[] = [
  { src: './static/work/plant1.jpg', alt: 'Plant 1' },
  { src: './static/work/plant2.jpg', alt: 'Plant 2' },
  { src: './static/work/plant3.jpg', alt: 'Plant 3' },
  { src: './static/work/plant4.jpg', alt: 'Plant 4' },
  { src: './static/work/plant5.jpg', alt: 'Plant 5' },
  { src: './static/work/sale.jpg', alt: 'Sale' },
  { src: './static/work/wires.jpg', alt: 'Wires' },
  { src: './static/work/1.jpg', alt: 'Material 1' },
  { src: './static/work/2.jpg', alt: 'Material 2' },
  { src: './static/work/3.jpg', alt: 'Material 3' },
  { src: './static/work/4.jpg', alt: 'Material 4' },
  { src: './static/work/5.jpg', alt: 'Material 5' },
  { src: './static/work/6.jpg', alt: 'Material 6' },
  { src: './static/work/7.jpg', alt: 'Material 7' },
  { src: './static/work/8.jpg', alt: 'Material 8' },
  { src: './static/work/9.jpg', alt: 'Material 9' },
  { src: './static/work/10.jpg', alt: 'Material 10' }
];

const rootElement = document.getElementById('logo-loop-root');

if (rootElement) {
  createRoot(rootElement).render(
    <LogoLoop
      logos={workImages}
      speed={90}
      direction="left"
      logoHeight={120}
      gap={24}
      hoverSpeed={60}
      pauseOnHover
      fadeOut
      className="logoloop--fade"
      ariaLabel="PCSTECH instrumentation gallery"
    />
  );
}
